type ViteEnvRecord = Record<string, string | undefined>;

const getEnvRecord = (): ViteEnvRecord | undefined => {
  return (import.meta as unknown as { env?: ViteEnvRecord }).env;
};

export const getEnv = (key: string): string | undefined => {
  return getEnvRecord()?.[key];
};

export const ensureEnv = (key: string): string => {
  const value = getEnv(key);
  if (!value) {
    throw new Error(`common-platform missing env: ${key}`);
  }
  return value;
};

export const getEnvBoolean = (key: string, defaultValue = false): boolean => {
  const value = getEnv(key);
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }

  return value.toLowerCase() === 'true';
};
